<template>
  <div
    @click="$router.push({ name: 'cp-reports' }).catch(() => {})"
    class="flex py-2 px-4 cursor-pointer"
    style="position: absolute; bottom: 5px; left: 5px"
    v-if="hasListManagement && hasPermission('vp.cockpit.managereports.show')"
  >
    <feather-icon
      icon="SettingsIcon"
      svgClasses="w-4 h-4"
      :class="{
        'text-white': this.$store.state.themeProps.theme === 'semi-dark',
      }"
    />
    <span
      :class="{
        'text-white': this.$store.state.themeProps.theme === 'semi-dark',
      }"
      class="semi-bold"
      >Manage reports</span
    >
  </div>
</template>

<script>
export default {
  computed: {
    hasListManagement() {
      return this.$store.getters["services/currentMenuHasListManagement"];
    },
  },
};
</script>
